import TableWithLoadingWrapper from '../../../../../components/generic/dataGrid'
import SearchBar from '../../../bankAccountsAll/tempComponents/searchBar'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import IgnoredCounterpartiesRowDropDown from './IgnoredCounterpartiesRowDropDown'

const IgnoredCounterpartiesTable = ({
  originalTableData,
  displayTableData,
  setDisplayTableData,
  isLoading,
  removeFromIgnoredTable,
  addToCleanTable,
}) => {
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      renderCell: (params) => {
        const { name } = params.row
        return <Typography variant='primary'>{name}</Typography>
      },
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      renderCell: (params) => {
        const { description } = params.row
        return <Typography variant='primary'>{description}</Typography>
      },
    },
    {
      field: 'dropdown',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => {
        return (
          <IgnoredCounterpartiesRowDropDown
            transactionCounterparty={params.row}
            removeFromIgnoredTable={removeFromIgnoredTable}
            addToCleanTable={addToCleanTable}
          />
        )
      },
    },
  ]
  return (
    <Stack spacing={1}>
      <SearchBar
        originalTableData={originalTableData}
        updateTableState={setDisplayTableData}
        searchKeys={[['name'], ['description']]}
        isLoading={isLoading}
      />
      <TableWithLoadingWrapper
        loading={isLoading}
        pagination={{
          paginationModel: {
            pageSize: 25,
            page: 0,
          },
        }}
        pageSizeOptions={[5, 10, 25]}
        columns={columns}
        dataSource={displayTableData}
        sortModel={[
          {
            field: 'name',
            sort: 'asc',
          },
        ]}
      />
    </Stack>
  )
}

export default IgnoredCounterpartiesTable
